import '../../TinyMceEditor/textStyles.css'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { DEFAULT_TE_CLASS_NAME } from 'Components/TinyMceEditor/constants'
import { Else, If, Then, When } from 'react-if'

// TODO need skeleton and isLoading prop
const DescriptionBlock = ({ description = '', isMobile = false, isWithAbout = true, className = '' }) =>
  !!description && (
    <If condition={!isMobile}>
      <Then>
        <Box
          maxWidth="100%"
          mt={2}
        >
          <When condition={isWithAbout}>
            <Typography
              variant="h6"
              color="text.secondary"
            >
              About
            </Typography>
          </When>

          <Box mt={3}>
            <article
              className={`${DEFAULT_TE_CLASS_NAME} ${className}`}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Box>
        </Box>
      </Then>
      <Else>
        <article
          className={`${DEFAULT_TE_CLASS_NAME} ${className}`}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Else>
    </If>
  )

export default DescriptionBlock
